import { render, staticRenderFns } from "./Alibaba-order-total.vue?vue&type=template&id=6c9ee83f&scoped=true&"
import script from "./Alibaba-order-total.vue?vue&type=script&lang=js&"
export * from "./Alibaba-order-total.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-order-total.vue?vue&type=style&index=0&id=6c9ee83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9ee83f",
  null
  
)

export default component.exports